<button class="btnClose" mat-icon-button (click)="selectAction($event)" aria-label="close icon" title="close">
  <mat-icon>close</mat-icon>
</button>
<h3 class="disclaimer__title">Rules for contributors</h3>
<div class="disclaimer__content">
  <div innerHTML="{{ content }}"></div>
</div>
